import types from "@/store/types";
var actions = {
    /**
     * 遷移開始
     */
    startTransition: function (_a) {
        var commit = _a.commit;
        commit(types.START_TRANSITION);
        commit(types.START_LEAVE);
    },
    /**
     * 遷移の折り返し
     */
    turnTransition: function (_a, payload) {
        var commit = _a.commit;
        commit(types.COMPLETE_LEAVE);
        commit(types.SET_PAGE_NAME, payload);
        commit(types.START_ENTER);
    },
    /**
     * 遷移完了
     */
    completeTransition: function (_a) {
        var commit = _a.commit;
        commit(types.COMPLETE_ENTER);
        commit(types.COMPLETE_TRANSITION);
    },
};
export default actions;
